import React from 'react';
import { NavLink } from 'react-router-dom';

var bgimg1 = require('./../../images/background/bg5.jpg');

class About2 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray">
                        <div className="container">
                            <div className="section-content">
                                <div className="row">
                                    <div className="col-xl-5 col-lg-5 col-md-12 ">
                                        <div className="home-2-about bg-bottom-left bg-no-repeat bg-cover" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        </div>
                                    </div>
                                    <div className="col-xl-7 col-lg-7 col-md-12">
                                        <div className="about-home-2">
                                            <h3 className="m-t0 sx-tilte">We Create Future</h3>
                                            <p>
                                                Welcome to Startups in J. Kumar Defence and Aerospace Private
                                                Ltd in order to further encourage indigenization in compliance with
                                                the Hon'ble Prime Minister's vision of "Atmanirbhar Bharat" In the
                                                past decade, the Indian business sector has undergone a huge
                                                difference, and it is now a sea of potential for entrepreneurs. Rising
                                                income levels, increased nancial literacy, a change in life style, and
                                                many other factors are among the major factors driving the
                                                expansion of the Indian business market, for Integrated Different
                                                Field Entrepreneurs Incubation Centre in response to the shifting
                                                patterns in the sector. The Incubation Program will concentrate on
                                                offering an affiliated platform and a wide range of support
                                                services, such as funding opportunities, networking, incubator
                                                space, and business help
                                            </p>
                                            {/* <div className="text-left">
                                            <NavLink to={"/about-us"} className="site-button-link">Read More</NavLink>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </>
        );
    }
};

export default About2;